import $ from 'jquery'
import lettering from 'lettering.js'

$(".cr-ajax-reviews-add-review").lettering()
